import React from 'react';
import { Pressable } from '../../buttons';
import { Icon } from '../../icon';
import { TagText } from '../../typography';
import { Tag } from './Tag';
import { getFilterTagVariant } from './tagUtils';

type Props = {
  readonly children: string;
  readonly onPress: () => void;
};

/**
 * Web counterpart of `FilterTag`. It renders a smaller label than native (`TagText` rather than
 * `FilterTagText`), which is why the two files stay separate.
 */
export const FilterTag = ({ children, onPress }: Props) => {
  const { iconType, labelColor, tagType } = getFilterTagVariant();

  return (
    <Pressable onPress={onPress}>
      <Tag
        icon={
          <Icon
            name="chevrondown-small"
            type={iconType}
          />
        }
        isPressable
        label={
          <TagText
            color={labelColor}
            variant="small"
          >
            {children}
          </TagText>
        }
        right
        type={tagType}
      />
    </Pressable>
  );
};
